import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
const BULK_UPDATE_NOTE_TABS_MUTATION = gql `
  mutation Admin_BulkUpdateNoteTabs($items: [EPBulkEditNoteTabItem!]!) {
    ep_bulkEditNoteTabs(items: $items) {
      conflictedNoteTabIDs
    }
  }
`;
export function useBulkUpdateNoteTabsMutation(options) {
    return useGQLMutation(BULK_UPDATE_NOTE_TABS_MUTATION, {
        ...options,
        update(cache, result, { variables }) {
            if (!variables?.items) {
                return;
            }
            const conflictedIDs = new Set(result.data?.ep_bulkEditNoteTabs?.conflictedNoteTabIDs ?? []);
            for (const item of variables.items) {
                if (conflictedIDs.has(item.noteTabID)) {
                    continue;
                }
                cache.modify({
                    id: cache.identify({
                        __typename: 'EPNoteTab',
                        id: item.noteTabID,
                    }),
                    fields: {
                        data(existingData) {
                            if (!existingData)
                                return item.data;
                            return {
                                ...existingData,
                                title: item.data.title ?? existingData.title,
                                content: item.data.content ?? existingData.content,
                                version: (item.data.version ?? existingData.version ?? 0) + 1,
                            };
                        },
                    },
                });
            }
        },
    });
}
